<template>
  <modal-template
    ref="modal"
    size="md"
    :title="title"
    type-modal="feed_tag_filter_modal"
  >
    <div class="modal-content__main">
      <d-form>

        <d-form-row>
          <!-- Filter Name -->
          <d-col md="12" class="form-group">
            <label>Nome do filtro</label>
            <d-input v-model="model.name" />
          </d-col>
        </d-form-row>

        <d-form-row>
          <!-- Conditions -->
          <d-col md="8" class="form-group mb-0">
            <label>Mostrar se:</label>
            <tag-select :items.sync="model.conditions.and" prefix="and" />
            <d-col class="col-12 p-0" v-for="(or, index) in model.conditions.or" :key="index">
              <label>ou <i class="fas fa-trash" @click="removeRow(index)"></i></label>
              <tag-select :items.sync="model.conditions.or[index]" :prefix="`or_${index}`"/>
            </d-col>
            <d-col class="col-12 p-0">
              <d-button type="button" theme="secondary" @click="addConditionalOr">Adicionar regra</d-button>
            </d-col>
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control w-100" >
      <d-button
        type="button"
        @click="confirmDeleteRow()"
        class="btn btn-sm btn-danger float-left"
      >Delete</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary float-right"
      >Salvar</d-button>
    </div>
    <confirmation-modal
      :cancel="closeConfirm"
      :confirm="deleteFilter"
      title="Confrimação de exclusão"
      message="Tem certeza que deseja excluir este filtro?"/>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import FeedService from '_services/rest/modules/feed';
import ModalTemplate from '_shared/Modal.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import { TAG_FILTER_MODEL, _OPEN_TAG_FILTER_MODAL_, TAG_FILTER_ITEM_MODEL } from '../TagModel';
import TagSelect from '../modal/TagSelect.vue';

export default {
  name: 'feed-filter-modal',
  components: {
    TagSelect,
    ModalTemplate,
    ConfirmationModal,
  },
  props: {
    title: {
      type: String,
      default: 'Novo filtro',
    },
  },
  data() {
    return {
      loading: false,
      model: cloneDeep(TAG_FILTER_MODEL),
    };
  },
  computed: {
    filters() {
      const { filterList } = this.$store.state.feed;
      if (filterList) {
        return filterList;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getFilterList',
      'getTagFilterList',
    ]),
    addConditionalOr() {
      this.model.conditions.or.push([{ ...TAG_FILTER_ITEM_MODEL }]);
    },
    close() {
      this.getTagFilterList();
      this.setToggle({ type: 'feed_tag_filter_modal', bool: false });
    },
    closeConfirm() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
    },
    deleteFilter() {
      FeedService.deleteTagFilter(this.model.id)
        .then(() => {
          this.activeAlert({ message: 'Filtro deletado com sucesso', theme: 'success' });
          this.closeConfirm();
          this.close();
        });
    },
    removeRow(index) {
      this.model.conditions.or.splice(index, 1);
    },
    getFilters() {
      if (this.filters.length === 0) {
        this.getFilterList();
      }
    },
    save() {
      FeedService.saveTagFilter(this.model)
        .then(() => {
          this.activeAlert({ message: 'Filtro salvo com sucesso', theme: 'success' });
          this.close();
        });
    },
  },
  mounted() {
    Events.$on(_OPEN_TAG_FILTER_MODAL_, filter => {
      this.model = { ...TAG_FILTER_MODEL, ...filter };
    });
    this.getFilters();
  },
};
</script>

<style lang="scss" scoped>

</style>
